"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlogPanel = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var BlogPanel = function (props) {
    var children = props.children, panelBodyClassName = props.panelBodyClassName, className = props.className, headline = props.headline;
    return (react_1.default.createElement(BlogPanelContainer, { className: (0, classnames_1.default)('panel panel-default', className) },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('panel-body', panelBodyClassName) },
            headline && react_1.default.createElement(Headline, null, headline),
            children)));
};
exports.BlogPanel = BlogPanel;
var BlogPanelContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 0 !important;\n"], ["\n  border-radius: 0 !important;\n"])));
var Headline = styled_components_1.default.h4(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 300;\n  text-decoration: none;\n  font-size: 1.6rem;\n  margin-top: 0;\n"], ["\n  font-weight: 300;\n  text-decoration: none;\n  font-size: 1.6rem;\n  margin-top: 0;\n"])));
exports.default = exports.BlogPanel;
var templateObject_1, templateObject_2;
